document.addEventListener('DOMContentLoaded', function() {
  const images = document.querySelectorAll('.product__media-item .media');
  
  images.forEach(function(container) {
    const img = container.querySelector('img');
    if (!img) return;
    
    container.style.overflow = 'hidden';
    container.style.cursor = 'crosshair';
    
    container.addEventListener('mousemove', function(e) {
      const rect = container.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      
      img.style.transformOrigin = x + '% ' + y + '%';
      img.style.transform = 'scale(2.5)';
      img.style.transition = 'transform 0.1s ease';
    });
    
    container.addEventListener('mouseleave', function() {
      img.style.transform = 'scale(1)';
      img.style.transition = 'transform 0.4s ease';
    });
  });
});